export default function (value) {
    const normalized = value?.toLowerCase();

    if (normalized === 'true') return 'Checked';
    if (normalized === 'false') return 'Not Checked';

    return '';
}